const chillout = require('chillout');

function isPinchZooming() {
	return window.visualViewport.scale > 1;
}

/**
 * カタログが読み込み済みか確認するための変数
 * 関数の重複実行を防ぐ
 */
let isLoaded = false;
let currentNum = 0;

const Catalogue = () => {

	const CatalogueLoad = () => {

		const catalogueWrap = document.getElementById('js-catalogue-wrap');
		const catalogue = document.getElementById('js-catalogue');

		if (!catalogueWrap) return;
		
		const catalogueItems = document.getElementsByClassName('catalogue-list__item');
		const catalogueList = document.getElementById('js-catalogue-list');

		const totalNum = catalogueItems.length - 1;
		const lastNum = totalNum;
		const currentNumInput = document.getElementById('js-current-num');
		const totalNumSpan = document.getElementById('js-total-num');

		catalogueItems[currentNum].classList.add('catalogue-list__item--visible');
		currentNumInput.value = currentNum;
		totalNumSpan.innerText = totalNum;
		currentNumInput.max = totalNum;

		// eslint-disable-next-line no-undef
		const iconPath = tmgcJsValue.path + 'dist/images/icons/';

		let innerHeight = window.innerHeight;

		catalogueWrap.style.height = innerHeight + 'px';

		window.addEventListener('resize', () => {

			innerHeight = window.innerHeight;

			catalogueWrap.style.height = innerHeight + 'px';
		})

		const changeDisabled = num => {
			/**
			 * 現在のページでボタン操作できるか判定
			 */
			const prevButton = document.getElementById('js-catalogue-prev-btn');
			const nextButton = document.getElementById('js-catalogue-next-btn');

			const moveFirstBtn = document.getElementById('js-catalogue-first-btn');
			const moveLastBtn = document.getElementById('js-catalogue-last-btn');

			if (num === 0) {
				prevButton.disabled = true;
				moveFirstBtn.disabled = true;
			} else {
				prevButton.disabled = false;
				moveFirstBtn.disabled = false;
			}

			if (num === totalNum) {
				nextButton.disabled = true;
				moveLastBtn.disabled = true;
			} else {
				nextButton.disabled = false;
				moveLastBtn.disabled = false;
			}
		}

		const changeInputNum = (num) => {

			currentNumInput.value = num;

			changeDisabled(num);
		}

		const movePrevPage = () => {
			
			if (currentNum !== 0) {
				catalogueItems[currentNum].classList.remove('catalogue-list__item--visible');
				currentNum--;
				catalogueItems[currentNum].classList.add('catalogue-list__item--visible');

				changeInputNum(currentNum);
			}
		}

		const moveNextPage = () => {
			if (currentNum !== lastNum) {
				catalogueItems[currentNum].classList.remove('catalogue-list__item--visible');
				currentNum++;
				catalogueItems[currentNum].classList.add('catalogue-list__item--visible');
				changeInputNum(currentNum);
			}
		}

		const prevBtn = document.getElementById('js-catalogue-prev-btn');
		const prevSlider = document.getElementById('js-slider-prev');

		prevBtn.addEventListener('click', e => {
			e.preventDefault();

			if (catalogueList.classList.contains('catalogue-list--list')) return;

			movePrevPage();
		});

		prevSlider.addEventListener('click', () => {

			if (catalogueList.classList.contains('catalogue-list--list')) return;

			movePrevPage();
		});

		const nextBtn = document.getElementById('js-catalogue-next-btn');
		const nextSlider = document.getElementById('js-slider-next');

		nextBtn.addEventListener('click', e => {
			e.preventDefault();

			if (catalogueList.classList.contains('catalogue-list--list')) return;
			
			moveNextPage();
		});

		nextSlider.addEventListener('click', e => {

			e.preventDefault();

			if (catalogueList.classList.contains('catalogue-list--list')) return;

			moveNextPage();
		});

		/**
		 * タッチイベント
		 */
		let touchStartX = 0;
		let touchEndX = 0;

		catalogueList.addEventListener('touchstart', e => {

			if (catalogueList.classList.contains('catalogue-list--list')) return;
			if (isPinchZooming()) return;

			touchStartX = e.changedTouches[0].clientX;
		});

		catalogueList.addEventListener('touchend', e => {

			if (catalogueList.classList.contains('catalogue-list--list')) return;
			if (isPinchZooming()) return;

			touchEndX = e.changedTouches[0].clientX;

			if (touchStartX - touchEndX > 30) {

				e.preventDefault(); // clickが発動しないように。

				moveNextPage();

			} else if (touchStartX - touchEndX < -30) {

				e.preventDefault(); // clickが発動しないように。
				
				movePrevPage();
				
			}
		});

		const firstBtn = document.getElementById('js-catalogue-first-btn');

		firstBtn.addEventListener('click', e => {
			e.preventDefault();

			if (catalogueList.classList.contains('catalogue-list--list')) return;

			if (currentNum !== 0) {
				catalogueItems[currentNum].classList.remove('catalogue-list__item--visible');
				currentNum = 0;
				catalogueItems[currentNum].classList.add('catalogue-list__item--visible');
				changeInputNum(currentNum);
			}
		})

		const lastBtn = document.getElementById('js-catalogue-last-btn');

		lastBtn.addEventListener('click', e => {
			e.preventDefault();

			if (catalogueList.classList.contains('catalogue-list--list')) return;

			if (currentNum !== lastNum) {
				catalogueItems[currentNum].classList.remove('catalogue-list__item--visible');
				currentNum = lastNum;
				catalogueItems[currentNum].classList.add('catalogue-list__item--visible');
				changeInputNum(currentNum);
			}
		});

		/**
		 * リストボタンをクリックした時の挙動
		 */
		const changeListBtn = document.getElementById('js-catalogue-list-btn');

		const changePageView = () => {

			window.scrollTo(0, 0);
			
			catalogueList.classList.remove('catalogue-list--list');
			catalogue.classList.remove('catalogue-content--list');
			catalogueWrap.classList.remove('catalogue-wrap--list');
			catalogueList.classList.add('catalogue-list--zoom');
			
			changeListBtn.innerHTML = `<img src="${iconPath}list-icon.svg" alt="一覧表示" width="19" height="19" />`;

		}

		

		// すでにイベントが追加されているか判定
		if (changeListBtn.dataset.eventAdded !== 'added') {
			
			changeListBtn.addEventListener('click', () => {

				changeListBtn.dataset.eventAdded = 'added';

				if (catalogueList.classList.contains('catalogue-list--list')) {
					
					changePageView();

				} else {
					catalogue.classList.add('catalogue-content--list');
					catalogueList.classList.add('catalogue-list--list');
					catalogueWrap.classList.add('catalogue-wrap--list');
					catalogueList.classList.remove('catalogue-list--zoom');
					catalogueList.style.width = '';
					catalogueList.style.height = '';

					catalogueWrap.style.height = '';

					changeListBtn.innerHTML = `<img src="${iconPath}page-icon.svg" alt="ページ表示" width="19" height="19" />`;
				}
			});
		}

		chillout.forEach([...catalogueItems], (item, index) => {
			item.dataset.num = index;

			item.addEventListener('click', function () {
				const value = parseInt(this.dataset.num, 10);

				if (catalogueList.classList.contains('catalogue-list--zoom'))
					return;

				catalogueItems[currentNum].classList.remove('catalogue-list__item--visible');
				currentNum = value;
				catalogueItems[currentNum].classList.add('catalogue-list__item--visible');
				changeInputNum(currentNum);

				changePageView();
			})
		});

		const moveBtn = document.getElementById('js-catalogue-move-btn');
		
		moveBtn.addEventListener('click',function() {
			let value = parseInt(currentNumInput.value, 10);

			if (currentNum === value) return;

			if (value < 0) {
				value = 0;
			}

			if (value > lastNum) {
				value = lastNum
			}

			catalogueItems[currentNum].classList.remove('catalogue-list__item--visible');
			currentNum = value;
			catalogueItems[currentNum].classList.add('catalogue-list__item--visible');

			changeInputNum(value);

			if (catalogueList.classList.contains('catalogue-list--list')) {

				changePageView();

			}
		})

		isLoaded = true;
	}

	/**
	 * ロード時にカタログの生成を発動
	 */
	if (!isLoaded) {
		CatalogueLoad();
	}
	
}

export default Catalogue;